// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Roboto, sans-serif;
  overflow-x: hidden;
}

body[data-floating-ui-scroll-lock] {
  padding-right: 0 !important;
}

@media (max-width: 768px) {
  [role="dialog"] {
    transform: none !important;
    overflow: hidden !important
  }
}

@supports (-webkit-touch-callout: none) { /*Note: This is a hack i found on the web to fix the Safari mobile's bar on the bottom obscuring part of the dialogs. Supposed to be applied only on Safari's and seems to work */
  @media (max-height: 700px) {
    [role="dialog"] {
      max-height: 90dvh !important;
      position: fixed;
      top: 0;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;IAC1B;EACF;AACF;;AAEA,0CAA0C,iLAAiL;EACzN;IACE;MACE,4BAA4B;MAC5B,eAAe;MACf,MAAM;IACR;EACF;AACF","sourcesContent":["body {\n  font-family: Roboto, sans-serif;\n  overflow-x: hidden;\n}\n\nbody[data-floating-ui-scroll-lock] {\n  padding-right: 0 !important;\n}\n\n@media (max-width: 768px) {\n  [role=\"dialog\"] {\n    transform: none !important;\n    overflow: hidden !important\n  }\n}\n\n@supports (-webkit-touch-callout: none) { /*Note: This is a hack i found on the web to fix the Safari mobile's bar on the bottom obscuring part of the dialogs. Supposed to be applied only on Safari's and seems to work */\n  @media (max-height: 700px) {\n    [role=\"dialog\"] {\n      max-height: 90dvh !important;\n      position: fixed;\n      top: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
